import ExternalLogger from "core-ui/client/src/app/ExternalLogger";
import idProofEvents from "./events/IDProofEvents";

var otpIdentityVerificationController = function ($injector, eventBus) {

    var vm = this;
    var $state = $injector.get('$state');
    var $stateParams = $injector.get('$stateParams');
    var logger = ExternalLogger.getInstance('otpIdentityVerificationController');
    vm.flowState =  $stateParams.flowState;
    vm.options = {
        onConfirm: function (phoneNumber, data) {
            logger.debug('otpIdentityVerificationController - onConfirmClick - [{0}]', [phoneNumber ? phoneNumber : null]);
            eventBus.dispatch(idProofEvents.OTP_AGREE_SEND_CODE, this);
            var params = {
                "phoneNumber": phoneNumber ? phoneNumber : null
            };
            if (data.state === 'ID_PROOFING_QUERIES') {
                $state.go('idProofQueries');
            } else if (data.state === 'MAIL_PIN') {
                $state.go('mailPin');
            } else if (data.state === 'ID_PROOFING_PIN_STATE') {
                $state.go('idProofWithPin');
            } else if (data.state === 'ID_PROOFING_OTP_VERIFY_CODE') {
                $state.go('otpIdentityVerificationCodeEntry', params);
            }
            else {
                $state.go('idProofError', { errorCode: data.errorCode });
            }
        },
        onCancel: function () {
            logger.debug('otpIdentityVerificationController - onCancelClick');
            eventBus.dispatch(idProofEvents.OTP_SKIP_MAIL_PIN, this);
            $state.go('mailPin', { optOut: 'optOut-Modal' });
        }
    };
};

otpIdentityVerificationController.$inject = ['$injector', 'eventBus'];
export default otpIdentityVerificationController;
